import { render, staticRenderFns } from "./HbStatusBadge.vue?vue&type=template&id=7b79f8bd&scoped=true"
import script from "./HbStatusBadge.vue?vue&type=script&lang=js"
export * from "./HbStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./HbStatusBadge.vue?vue&type=style&index=0&id=7b79f8bd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b79f8bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b79f8bd')) {
      api.createRecord('7b79f8bd', component.options)
    } else {
      api.reload('7b79f8bd', component.options)
    }
    module.hot.accept("./HbStatusBadge.vue?vue&type=template&id=7b79f8bd&scoped=true", function () {
      api.rerender('7b79f8bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/hubee/HbStatusBadge.vue"
export default component.exports